import {
  NEXT_LEVEL_LOGO_ALT,
  NEXT_LEVEL_LOGO_SRC,
  NEXT_LEVEL_MARKETPLACE_URL,
  getNextLevelLogoProps,
  isNextLevelMarketplace,
} from '@/housefolios-components/PublicPages/shared/nextLevelBranding'

export {
  NEXT_LEVEL_LOGO_ALT,
  NEXT_LEVEL_LOGO_SRC,
  NEXT_LEVEL_MARKETPLACE_URL,
  getNextLevelLogoProps,
  isNextLevelMarketplace,
}

/**
 * Header chrome for public View Properties / Sold Properties pages.
 * Next Level swaps the FA icon for the brand logo but keeps marketplace
 * title + “Purchase your next property” subtext. Other marketplaces keep
 * title + FA icon.
 */
export function getPublicMarketplaceHeaderProps(marketplace) {
  const title = marketplace
    ? `${marketplace.name}`
    : 'Housefolios Marketplace'
  const description = 'Purchase your next property'
  const logoProps = getNextLevelLogoProps(marketplace)

  if (logoProps.logoSrc) {
    return {
      title,
      description,
      icon: undefined,
      ...logoProps,
    }
  }

  return {
    title,
    description,
    icon: ['fas', 'sign-hanging'],
    logoSrc: undefined,
    logoAlt: undefined,
  }
}
